import { HStack, useBreakpointValue } from "@gluestack-ui/themed";

import { Button } from "@repo/core/components/core/Button";

import { AlertModalFooterProps } from "./types";
import {
  IModalTemplateType,
  IModalOption
} from "../../../types";
import { OptionStyleMap } from "../../../OptionsModal/constants";

export const AlertModalFooter = ({ options }: AlertModalFooterProps) => {
  try {
    const isMobileValue = useBreakpointValue({
      base: true,
      md: false
    });
    const isMobile = isMobileValue ?? true;

    if (!options || !Array.isArray(options) || options.length === 0) {
      return null;
    }

    const validOptions = options
      .filter(
        (option): option is IModalOption =>
          !!(
            option &&
            typeof option === "object" &&
            option.label &&
            typeof option.label === "string" &&
            option.type !== undefined &&
            option.type !== null &&
            OptionStyleMap[option.type as IModalTemplateType]
          )
      )
      .map((option) => {
        const type =
          option.type !== undefined && option.type !== null
            ? (option.type as IModalTemplateType)
            : IModalTemplateType.info;
        const style = OptionStyleMap[type];

        if (!style || !style.variant || style.action === undefined) {
          return null;
        }

        return {
          ...option,
          type,
          style
        };
      })
      .filter(
        (option): option is NonNullable<typeof option> => option !== null
      );

    if (validOptions.length === 0) {
      return null;
    }

    return (
      <HStack
        gap="$3"
        width="$full"
        mb="$4"
        flexDirection={isMobile ? "column" : "row-reverse"}
        alignItems="center"
      >
        {validOptions.map((option) => {
          if (!option || !option.style) {
            return null;
          }

          const {
            label,
            onPress,
            leftIcon,
            isDisabled,
            rightIcon,
            style
          } = option;

          return (
            <Button
              key={label}
              size="lg"
              flex={isMobile ? undefined : 1}
              width="$full"
              isDisabled={isDisabled}
              variant={style.variant}
              action={style.action}
              onPress={onPress}
              leftIcon={leftIcon}
              rightIcon={rightIcon}
              text={label}
            />
          );
        })}
      </HStack>
    );
  } catch (error) {
    console.error("Error rendering AlertModalFooter:", error);
    return null;
  }
};
